export function getIsContentWrapped(node: HTMLDivElement) {
    if (!node || !node.children || !node.children.length) {
        return false;
    }

    var itemCount = node.children.length;

    for (var i = 0; i < itemCount; i++) {
        for (var j = 0; j < itemCount; j++) {
            if (
                node.children.item(i) &&
                node.children.item(j) &&
                // @ts-ignore
                node.children.item(i).offsetTop >
                    // @ts-ignore
                    node.children.item(j).offsetTop
            ) {
                return true;
            }
        }
    }

    return false;
}
